import {
	Car,
	CreditCard as CreditCardIcon,
	GraduationCap,
	HandCoins,
	House,
	type LucideIcon,
} from "lucide-react";
import type { DebtType } from "./debt-types";

// Separate from `debt-types.ts` so the API route's validator import stays icon-free.
export const DEBT_TYPE_ICONS: Record<DebtType, LucideIcon> = {
	ConsumerLoan: HandCoins,
	Creditcard: CreditCardIcon,
	MortgageLoan: House,
	VehicleLoan: Car,
	StudentLoan: GraduationCap,
};
